import * as R from 'ramda'

export const getFilterInitState =
  (query = {}) =>
  (acc, filterConfig) => ({
    ...acc,
    [filterConfig.key]: query[filterConfig.key] || filterConfig.defaultValue,
  })

export const getFilterQuery = (filter, filtersConfigs) =>
  R.reduce(
    (acc, filterConfig) => ({ ...acc, ...filterConfig.getQuery(filter) }),
    {},
    filtersConfigs,
  )

export const getIsFilteredResults = (filtersConfigs, filter) =>
  filtersConfigs.some(conf => filter[conf.key] !== conf.defaultValue)

export const getDepartmentValueFromQuery = (query, departments) => {
  if (R.isNil(query.department)) {
    return []
  }

  const queryDepartments = Array.isArray(query.department)
    ? query.department
    : [query.department]

  return queryDepartments.map(id => {
    const dep = departments.find(resp => resp.id === Number(id))

    return {
      value: dep.id,
      label: dep.name,
    }
  })
}
